/**
 * V3-036: one call per data type per page load. While a GET for a key is in flight, a second
 * caller for the same key gets the same promise instead of a second request. That covers
 * React's StrictMode running each effect twice in development (the doubling seen on Test) and two
 * parts of a page asking for the same record at once (the unit page and its Repair History tab).
 *
 * Only in-flight requests are shared: once a request settles it is forgotten, so a later refresh
 * (after a save, or Retry) always goes to the server.
 */
const inFlight = new Map<string, Promise<unknown>>();

export function sharedRequest<T>(key: string, request: () => Promise<T>): Promise<T> {
  const existing = inFlight.get(key) as Promise<T> | undefined;
  if (existing) return existing;
  const promise = request().finally(() => inFlight.delete(key));
  inFlight.set(key, promise);
  return promise;
}

/** Test hook. */
export function sharedRequestsInFlight(): number {
  return inFlight.size;
}
